import React, { Component } from 'react';
import { store } from 'Store/store.index';
import { Modal, Radio } from 'antd';
import './fwConvertImgType.scss';
export default class fwConvertImgType extends Component {
  constructor(props) {
    super(props);
  }
  componentDidMount() {
    store.convert.getConvertType("convert-pdf-to-png")
  }
  componentWillUnmount() {}
  /**
   * [closeModal 关闭弹框]
   *
   * @return  {[type]}  [return description]
   */
  closeModal(){
    store.convert.getIsShowFwConvertImgType(false);
  }
  /**
   * [confirm 确认转换类型]
   *
   * @return  {[type]}  [return description]
   */
  confirm(){
    store.convert.getIsShowFwConvertImgType(false);
    store.convert.getIsShowFwConvertModal(true);
  }
  /**
   * [onChange 获取radio值]
   *
   * @param   {[type]}  e  [e description]
   *
   * @return  {[type]}     [return description]
   */
  onChange(e){
    store.convert.getConvertType(e.target.value)
  }
  render() {
    return (
      <React.Fragment>
        <Modal 
          title="PDF转图片" 
          visible={true}
          onOk={this.confirm}
          onCancel={this.closeModal}
          width="446px"
          height="260px"
          className="fwConvertImgType">
            <span className="label">转出类型</span>
            <div className='fwConvertImgTypeMain'>
              <Radio.Group onChange={this.onChange} defaultValue="convert-pdf-to-png">
                <Radio value={"convert-pdf-to-png"}>PNG</Radio>
                <Radio value={"convert-pdf-to-jpg"}>JPEG</Radio>
                <Radio value={"convert-pdf-to-longPng"}>长图</Radio>
              </Radio.Group>
            </div>
        </Modal>
      </React.Fragment>
    );
  }
}
